// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"70dedfa6e6deeee098f8","453":"fb66a9ae7affa85af196"}[chunkId] + ".js";
};